export default __webpack_public_path__ + "static/media/noun_Eye_3907900.8a2d9fe7.png";